import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Notifier } from "../../ecosystem";
import StatusBanner from '../../common/StatusBanner';
import { rxRoute } from "../../../helpers/formatting";

class ClosedPharmacy extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { prescriptions, technicalHelpDeskNumber } = this.props;
        return (
            <div className="col-12 pharmacy-confirmation-container pharmacy-closure-failure">
                <StatusBanner bannerAlignment="left" bannerMsg="We were unable to submit your request." failedStatus />
                <div className="row confirmation-summary-container">
                    <div className="col-12 maxWidth-content">
                        <h2 className="h5">Prescriptions:</h2>
                        <div className="row">
                            <div className="col-12 confirm-rx-list-container refill-failure">
                                <div className="row confirm-rx-list">
                                    {prescriptions && prescriptions.length > 0 && prescriptions.map((item, key) =>
                                    (<div key={key} className="col-12 col-lg-6">
                                        <div className="confirm-rx-list__item">
                                            <div className="rx-img-container">
                                                <div className="confirm-rx-list__img">
                                                    <img src={(!item.ndcImageURL || item.ndcImageURL === "") ? "/images/prescription_placeholder.jpg" : item.ndcImageURL} alt={item.DrugName + " photo"} className="img-responsive" />
                                                </div>
                                            </div>
                                            <div className="confirm-rx-list__info">
                                                <div>{item.DrugName}</div>
                                                <div>RX No. {item.RxNumber}</div>
                                            </div>
                                        </div>
                                    </div>)
                                    )}
                                    <div className="col-12">
                                        <div className="row meds-moving-notifier">
                                            <div className="col-12">
                                                <Notifier icon="exclamation" colorStyle="error" variant="banner"
                                                    link={{
                                                        label: "Go to Medications",
                                                        to: { pathname: '/currentmeds' },
                                                        onClick: () => logUI("MBHWeb.UI.RX.MedicationsBanner.Medications.Click", new Date(), Tools.getURLPath())
                                                    }}>
                                                    Our pharmacy is migrating to a new section. You can now find your medications in the Medications section.
                                                </Notifier>
                                            </div>
                                        </div>
                                        {/*<div className="rx-confirmation-status-msg failed-rx details-icon-prepend">
                                            <div className="icon-col">
                                                <span className="icon-important" />
                                            </div>
                                            <div className="details-col">
                                                The pickup location has permanently closed. Transfer these prescriptions to another location to refill them.
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <Link to={{ pathname: rxRoute('bswTransfer') }} className="btn btn-primary">TRANSFER PRESCRIPTIONS</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        technicalHelpDeskNumber: state.session.serverData.technicalHelpDeskNumber
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosedPharmacy);